import { render } from "./DatePickerWeek.vue?vue&type=template&id=3868b098&scoped=true"
import script from "./DatePickerWeek.vue?vue&type=script&lang=js"
export * from "./DatePickerWeek.vue?vue&type=script&lang=js"

import "./DatePickerWeek.vue?vue&type=style&index=0&id=3868b098&scoped=true&lang=scss"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3868b098"]])

export default __exports__